// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
//TODO хуже панель нужно поискать
//TODO рождена в муках
//TODO живёт в муках
//TODO и будет страдать в муках, каждый кто будет ее править

import { Connection } from "../../Commons/Connection.ts";
import { Resources } from "../../Commons/properties/Resources.ts";
import { LinkedSystem, LinkedSystemAccLinkingValue } from "../misc/LinkedSystem.js";
import { contextMenuHandler } from "../../Utils/AppHandlers.js";
import { PortfolioManagement } from "../../Portfolio/PortfolioManagement.js";
import { AccountWidgetTemplate } from "../../templates.js";
import { ExportScreen } from "../screen/ExportScreen.js";
import { TerceraChangePasswordScreen } from "../screen/TerceraChangePasswordScreen.js";
import { WithdrawalScreen } from "../screen/WithdrawalScreen.js";
import { PanelNames } from "../UtilsClasses/FactoryConstants.ts";
import { TOP_WINDOWS_MARGIN } from "../UtilsClasses/SizeConstants.js";
import { Control } from "./Control.js";
import { ContainerControl } from "./ContainerControl.js";
import { RulesSet } from "../../Utils/Rules/RulesSet.ts";
import { Account } from "../../Commons/cache/Account.ts";
import { Asset } from "../../Commons/cache/Asset.ts";
import { DynProperty } from "../../Commons/DynProperty.ts";
import { TradingLockUtils } from "../../Utils/TradingLockUtils.ts";
import { DataCache } from "../../Commons/DataCache.ts";
import { SessionSettings } from "../../Commons/SessionSettings.ts";
import { CustomerAccess } from "../../Commons/CustomerAccess/CustomerAccess.ts";
import { MainWindowManager } from "../UtilsClasses/MainWindowManager.js";
import { WorkSpaceManager } from "../WorkSpace/WorkSpaceManager.ts";
import { CloseAccountScreen } from "../screen/CloseAccountScreen.ts";

export let AccountWidget = ContainerControl.extend({
    data: function ()
    {
        return {
            DragNDropInProcess: false,
            leftHeader: "",
            rightHeader: "",
            leftData: "",
            rightData: "",
            lefttooltip: "",
            righttooltip: "",
            accBtnText: Resources.getResource('accountDetailsWidget.DropdownButton'),
            accBtnTooltip: Resources.getResource('accountDetailsWidget.DropdownButton.Tooltip'),
            infoBtnTooltip: Resources.getResource("panel.AccountDetailsPanel.InfoTooltip"),
            visible: true,
            visibleInfoBtn: false,
            focusedAccWidget: false
        };
    },
    template: AccountWidgetTemplate,
    assetComboBoxValue: null,
    accountLinkValue: null,
    leftValueSkip: false,
    rightValueSkip: false
});

AccountWidget.prototype.oncomplete = function ()
{
    ContainerControl.prototype.oncomplete.call(this)
    this.ClosedResizeBtnsHandler = this.resizeBtns.bind(this);
    this.myAccountDetailsPanel = null;
    WorkSpaceManager.OnWorkSpaceChanged.Subscribe(this.AccountPanelReinit, this);
    this.on("clicked", function ()
    {
        let mWindow = $(window);
        var wWidth = mWindow.width();
        this.ShowAccountDetailsPanel({ X: document.getElementsByClassName("accountWidgetDivStyle")[0].offsetLeft, Y: TOP_WINDOWS_MARGIN });
    });
    this.on("accBtnClick", function ()
    {
        let items = [];
        let control = MainWindowManager.MainWindow.Controls.accountWidget.Controls.accountMenu;

        let focusedAccount = function ()
        {
            contextMenuHandler.off(Control.Events.LostFocus, focusedAccount);
            control.set("focused", false);
            MainWindowManager.MainWindow.Controls.accountWidget.set("focusedAccWidget", false);
            this.set({ visibleInfoBtn: false });
        }.bind(this)

        if (CustomerAccess.panelAllowed(PanelNames.AssetBalancesPanel))
            items.push({
                style: "js-AccountMenu-Accounts", name: "accounts", text: Resources.getResource("panel.assetBalances"), event: function ()
                {
                    MainWindowManager.Factory.addPanel(PanelNames.AssetBalancesPanel);
                }
            });

        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_RESERVER_WITHDRAWAL) && !Resources.isHidden('ribbon.tools.withdrawal'))
        {
            items.push({ style: "js-AccountMenu-Withdrawal", name: "Withdrawal", text: Resources.getResource("ribbon.tools.withdrawal"), event: function () { WithdrawalScreen.show() } });
        }

        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_REPORT) && !Resources.isHidden('ribbon.tools.reports'))
        {
            items.push({ style: "js-AccountMenu-Reports", name: "reports", text: Resources.getResource("ribbon.tools.reports"), event: function () { MainWindowManager.Factory.addPanel(PanelNames.ReportsPanel); } });
        }

        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_PRODUCTS) && !Resources.isHidden('ribbon.tools.products'))
        {
            items.push({ style: "js-AccountMenu-Products", name: "products", text: Resources.getResource("ribbon.tools.products"), event: function () { MainWindowManager.Factory.addPanel(PanelNames.ProductsPanel); } });
        }

        if (DataCache.IsPortfolioAllowedForAnyAccount() && !Resources.isHidden('ribbon.tools.portfolio'))
        {
            items.push({ style: "js-AccountMenu-Portfolio", name: "portfolio", text: Resources.getResource("ribbon.tools.portfolio"), event: function () { PortfolioManagement.LogInPortfolio(window, Connection.vendor.loginParams) } });
        }

        if (DataCache.isAllowedForMyUser(RulesSet.ALLOW_CHANGE_PASSWORD))
        {
            items.push({ separator: true })
            if (TradingLockUtils.IsUseLockTradingByPassword && !Resources.isHidden('ribbon.changeTradingPass'))    // #89340 & #94446
                items.push({ style: "js-AccountMenu-ChangeTradingPassword", name: "changeTPWD", text: Resources.getResource("screen.changeTradingPass.title"), event: function () { TerceraChangePasswordScreen.show(null, null, null, true) } });
            items.push({ style: "js-AccountMenu-ChangePassword", name: "changePWD", text: Resources.getResource("screen.changepass.title"), event: function () { TerceraChangePasswordScreen.show() } });
        }

        items = items.concat(MainWindowManager.MainWindow.getExternalAccountMenuItems())

        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_CLOSE_ACCOUNT))
        {
            items.push({ separator: true });
            items.push({ style: "js-AccountMenu-DeleteAccount", name: "deleteAcc", text: Resources.getResource("ribbon.closeAccount"), event: () => { CloseAccountScreen.ShowMsg(); } });
        }

        contextMenuHandler.on(Control.Events.LostFocus, focusedAccount);
        contextMenuHandler.Show(items, document.getElementsByName("accountMenu")[0].offsetLeft, TOP_WINDOWS_MARGIN);
        control.set("focused", true);
        MainWindowManager.MainWindow.Controls.accountWidget.set("focusedAccWidget", true);
        this.set({ visibleInfoBtn: true });
    });
    this.on("leftUp", function ()
    {
        let dragedData = this.getDragedRowId(this.clickedRowIndex);
        this.leftRowId = dragedData.Id
        this.leftParams = dragedData.Parameters
        this.leftValueSkip = this.leftParams.Hidden;
        this.leftDataProvider = dragedData.DataProvider;
        this.leftClicked = this.clickedRowIndex;
        this.set({ leftHeader: Resources.getResource(this.leftParams.HeaderKey) });
        this.set({ leftData: this.leftDataProvider.GetVerticalPanelValueHandler(this.leftRowId, this.leftDataProvider, this.leftDataProvider.sett) });
        this.set({ lefttooltip: Resources.IsResourcePresent(this.leftParams.TooltipKey) ? Resources.getResource(this.leftParams.TooltipKey) : Resources.getResource(this.leftParams.HeaderKey) });
        //TODO пока не придумал куда сохранять
        SessionSettings.save();
    });
    this.on("rightUp", function ()
    {
        let dragedData = this.getDragedRowId(this.clickedRowIndex);
        this.rightRowId = dragedData.Id
        this.rightParams = dragedData.Parameters
        this.rightValueSkip = this.rightParams.Hidden;
        this.rightDataProvider = dragedData.DataProvider;
        this.rightClicked = this.clickedRowIndex;
        this.set({ rightHeader: Resources.getResource(this.rightParams.HeaderKey) });
        this.set({ rightData: this.rightDataProvider.GetVerticalPanelValueHandler(this.rightRowId, this.rightDataProvider, this.rightDataProvider.sett) });
        this.set({ righttooltip: Resources.IsResourcePresent(this.rightParams.TooltipKey) ? Resources.getResource(this.rightParams.TooltipKey) : Resources.getResource(this.rightParams.HeaderKey) });
        //TODO пока не придумал куда сохранять
        SessionSettings.save();
    });

    Control.Ticker.Subscribe(this.UpdateData, this);
    SessionSettings.AdditionalPropertiesHandlers.push(this.Properties.bind(this));
    SessionSettings.AdditionalCallBacksHandlers.push(this.callBack.bind(this));
    Resources.onLocaleChange.Subscribe(this.Localize, this)
}

AccountWidget.prototype.Properties = function ()
{
    let properties = [];
    properties.push(new DynProperty("rightRowId", this.rightRowId, DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("leftRowId", this.leftRowId, DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    if (this.myAccountDetailsPanel && this.myAccountDetailsPanel.myAccLookup)
    {
        properties.push(new DynProperty("AccountId", this.myAccountDetailsPanel.myAccLookup.get('selectedItem').AcctNumber, DynProperty.STRING, DynProperty.HIDDEN_GROUP));
        let selectedLinkValue = this.myAccountDetailsPanel.myAccLinkBtn.get('selectedLinkValue');
        if (Object.keys(DataCache.Accounts).length === 1)
            selectedLinkValue = -1;
        properties.push(new DynProperty("accountLinkValue", selectedLinkValue, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        if (this.myAccountDetailsPanel.assetComboBox)//always exist if myAccountDetailsPanel exist
            properties.push(new DynProperty("assetComboBoxValue", this.myAccountDetailsPanel.assetComboBox.get('selectedItem'), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    }
    return properties;
}

AccountWidget.prototype.callBack = function (newProperties)
{
    this.rightRowId = DynProperty.getPropValue(newProperties, "rightRowId") || 6;
    this.leftRowId = DynProperty.getPropValue(newProperties, "leftRowId") || 2;
    this.AccountId = DynProperty.getPropValue(newProperties, "AccountId") || DataCache.getPrimaryAccount().AcctNumber;
    this.assetComboBoxValue = DynProperty.getPropValue(newProperties, "assetComboBoxValue");
    this.accountLinkValue = DynProperty.getPropValue(newProperties, "accountLinkValue");
    if (Object.keys(DataCache.Accounts).length === 1)
        this.accountLinkValue = -1;
    if (this.myAccountDetailsPanel && this.myAccountDetailsPanel.myAccLookup)
        this.myAccountDetailsPanel.myAccLinkBtn.set('selectedLinkValue', this.accountLinkValue)
    this.UpdateDataRelation();
}

AccountWidget.prototype.Localize = function ()
{
    this.set({
        accBtnText: Resources.getResource('accountDetailsWidget.DropdownButton'),
        accBtnTooltip: Resources.getResource('accountDetailsWidget.DropdownButton.Tooltip'),
        infoBtnTooltip: Resources.getResource("panel.AccountDetailsPanel.InfoTooltip"),
    });
}

AccountWidget.prototype.UpdateDataRelation = function ()
{
    if (!this.myAccountDetailsPanel)
        return;

    if (this.AccountId)
        this.myAccountDetailsPanel.accountLink_In(this.AccountId);

    if (this.assetComboBoxValue && this.myAccountDetailsPanel.assetComboBox)
    {
        let idItem = this.assetComboBoxValue.value.Id
        this.myAccountDetailsPanel.selectAsset(idItem);
    }

    if (this.accountLinkValue && WorkSpaceManager.currentWorkspace)
    {
        LinkedSystem.accLinkingActive = this.accountLinkValue == LinkedSystemAccLinkingValue || DataCache.EnableForceLinkingByAccount();

        let acc = this.myAccountDetailsPanel.myAccLookup.get('selectedItem').BstrAccount

        LinkedSystem.accLinkingActive ? LinkedSystem.accLinkingOn(acc) : LinkedSystem.accLinkingOff()
    }

    let accItems = this.myAccountDetailsPanel.VerticalPanelDataProvider.Source;
    if (!accItems)
        return;
    let assetBalanceItem = accItems[0];

    if (!assetBalanceItem)
        return;

    if (this.leftRowId && !isNaN(this.leftRowId))
    {
        let tmp_params = assetBalanceItem.GetColumnParams(this.leftRowId);
        if (tmp_params.Hidden && this.leftDataProvider)
        {
            let allcurentvisible = this.leftDataProvider.GetItemsIDHandler(this.leftDataProvider, this.leftDataProvider.sett);
            if (allcurentvisible.length)
            {
                let newId = parseInt(allcurentvisible[0]);
                this.leftRowId = newId;
                tmp_params = assetBalanceItem.GetColumnParams(newId);
            }
        }
        this._setLeftStartData(tmp_params);
    }
    else
    {
        let tmp_rowKey = this.GetSortHeaderKey(assetBalanceItem, this.leftRowId);
        if (!tmp_rowKey && this.leftDataProvider)
        {
            let allcurentvisible = this.leftDataProvider.GetItemsIDHandler(this.leftDataProvider, this.leftDataProvider.sett);
            if (allcurentvisible.length)
            {
                let newId = parseInt(allcurentvisible[0]);
                this.leftRowId = newId;
                this._setLeftStartData(assetBalanceItem.GetColumnParams(newId));
            }
        }
        else
        {
            let leftRowKey = tmp_rowKey;
            this.leftValueSkip = false;
            this.set({
                leftHeader: Resources.getResource(leftRowKey),
                lefttooltip: Resources.getResource(leftRowKey)
            }).then(this.ClosedResizeBtnsHandler);
        }
    }

    if (this.rightRowId && !isNaN(this.rightRowId))
    {
        let tmp_params = assetBalanceItem.GetColumnParams(this.rightRowId);
        if (tmp_params.Hidden && this.rightDataProvider)
        {
            let allcurentvisible = this.rightDataProvider.GetItemsIDHandler(this.rightDataProvider, this.rightDataProvider.sett);
            if (allcurentvisible.length)
            {
                let newId = parseInt(allcurentvisible[0]);
                this.rightRowId = newId;
                tmp_params = assetBalanceItem.GetColumnParams(newId);
            }
        }
        this._setRigthStartData(tmp_params);
    }
    else
    {
        let tmp_rowKey = this.GetSortHeaderKey(assetBalanceItem, this.rightRowId);
        if (!tmp_rowKey && this.rightDataProvider)
        {
            let allcurentvisible = this.rightDataProvider.GetItemsIDHandler(this.rightDataProvider, this.rightDataProvider.sett);
            if (allcurentvisible.length)
            {
                let newId = parseInt(allcurentvisible[0]);
                this.rightRowId = newId;
                this._setRigthStartData(assetBalanceItem.GetColumnParams(newId));
            }
        }
        else
        {
            let rightRowKey = tmp_rowKey;
            this.rightValueSkip = false;
            this.set({
                rightHeader: Resources.getResource(rightRowKey),
                righttooltip: Resources.getResource(rightRowKey)
            }).then(this.ClosedResizeBtnsHandler);
        }
    }
    this.leftDataProvider = this.rightDataProvider = this.myAccountDetailsPanel.VerticalPanelDataProvider;
}
AccountWidget.prototype._setLeftStartData = function (leftParams)
{
    this.leftParams = leftParams
    this.leftValueSkip = this.leftParams.Hidden;
    this.set({
        leftHeader: Resources.getResource(this.leftParams.HeaderKey),
        lefttooltip: Resources.IsResourcePresent(this.leftParams.TooltipKey) ? Resources.getResource(this.leftParams.TooltipKey) : Resources.getResource(this.leftParams.HeaderKey)
    }).then(this.ClosedResizeBtnsHandler);
}

AccountWidget.prototype._setRigthStartData = function (rightParams)
{
    this.rightParams = rightParams;
    this.rightValueSkip = this.rightParams.Hidden;
    this.set({
        rightHeader: Resources.getResource(this.rightParams.HeaderKey),
        righttooltip: Resources.IsResourcePresent(this.rightParams.TooltipKey) ? Resources.getResource(this.rightParams.TooltipKey) : Resources.getResource(this.rightParams.HeaderKey)
    }).then(this.ClosedResizeBtnsHandler);
}

AccountWidget.prototype.getDragedRowId = function (index)
{
    let dp = this.myAccountDetailsPanel.VerticalPanelDataProvider;
    let accItems = dp.Source;
    let assetBalanceItem = accItems[0];
    let row = this.myAccountDetailsPanel.quickTableRactive.quickTable.rowsArray[index];
    let id = parseInt(row.item.itemId);
    let params = new Object();
    //TODO hotest FIX
    if (isNaN(id))
    {
        id = row.item.itemId;
        params = { HeaderKey: row.item.RowKey, TooltipKey: row.item.RowKey }
    }
    else
        params = assetBalanceItem.GetColumnParams(id)
    return { Id: id, Parameters: params, DataProvider: dp };
}

AccountWidget.prototype.GetSortHeaderKey = function (assetBalanceItem, headerKey)
{
    if (assetBalanceItem === null)
        return "";

    if (assetBalanceItem.Account && assetBalanceItem.Account.AccountAdditionalInfo !== null && assetBalanceItem.Account.AccountAdditionalInfo[headerKey])
        return assetBalanceItem.Account.AccountAdditionalInfo[headerKey].NameKey;
    else if (assetBalanceItem.AssetBalance && assetBalanceItem.AssetBalance.AssetAdditionalInfo !== null && assetBalanceItem.AssetBalance.AssetAdditionalInfo[headerKey])
        return assetBalanceItem.AssetBalance.AssetAdditionalInfo[headerKey].NameKey;
    else
        return "";
}

AccountWidget.prototype.UpdateData = function ()
{
    if (!DataCache.Loaded)
        return;

    if (this.leftValueSkip)
        this.set({ leftData: "" });
    else if (this.leftDataProvider)
    {
        if (this.leftClicked !== undefined || this.leftClicked !== null)// WTF with this condition ???? always true
            this.leftClicked = this.findRowId(this.leftRowId, this.leftDataProvider);
        let value = this.leftDataProvider.GetVerticalPanelValueHandler(this.leftRowId, this.leftDataProvider, this.leftDataProvider.sett, this.leftClicked);
        // if (value)
        // {
        this.set({ leftData: value });
        let color;
        let row = this.myAccountDetailsPanel.quickTableRactive.quickTable.rows[this.leftClicked];
        if (row)
            color = row.cells[1].ForeColor;
        if (!color)
            color = "#e4e2e2";
        this.set({ lefttColor: color });
        // }
    }
    if (this.rightValueSkip)
        this.set({ rightData: "" });
    else if (this.rightDataProvider)
    {
        if (this.rightClicked !== undefined || this.rightClicked !== null)// WTF with this condition ???? always true
            this.rightClicked = this.findRowId(this.rightRowId, this.rightDataProvider);

        let value = this.rightDataProvider.GetVerticalPanelValueHandler(this.rightRowId, this.rightDataProvider, this.rightDataProvider.sett, this.rightClicked)
        // if (value)
        // {
        this.set({ rightData: value });
        let color;
        let row = this.myAccountDetailsPanel.quickTableRactive.quickTable.rows[this.rightClicked];
        if (row)
            color = row.cells[1].ForeColor;
        if (!color)
            color = "#e4e2e2";
        this.set({ rightColor: color });
        // }
    }

    this.resizeBtns();
}

AccountWidget.prototype.findRowId = function (id, dp)
{
    let items = dp.generatedTableItems;
    for (let i = 0; i < items.length; i++)
    {
        let item = items[i];
        if (item.itemId == id)
            return item.ItemId;
    }
}

AccountWidget.prototype.AccountPanelReinit = function ()
{
    if (!DataCache.Loaded)
    {
        DataCache.OnReintialize.Subscribe(this.AccountPanelReinit, this);
        return;
    }
    let noPanell = !this.myAccountDetailsPanel;
    let disposed = this.myAccountDetailsPanel && this.myAccountDetailsPanel.torndown;
    let this$ = this;
    this.set({ visible: CustomerAccess.panelAllowed(PanelNames.AccountDetailsPanel) });

    if (noPanell || disposed)
    {
        if (disposed)
        {
            this.myAccountDetailsPanel.quickTableRactive.quickTable.onTableMouseUP.UnSubscribe(this.onTableMouseUP, this);
            this.myAccountDetailsPanel.quickTableRactive.quickTable.onTableMouseDown.UnSubscribe(this.onTableMouseDown, this);
            this.myAccountDetailsPanel.quickTableRactive.quickTable.onTableMouseMove.UnSubscribe(this.onTableMouseMove, this);
            this$.PrewProp = this.Properties();
        }

        this.myAccountDetailsPanel = MainWindowManager.Factory.createPanel(PanelNames.AccountDetailsPanel);

        MainWindowManager.AccountDetailsPanel = this.myAccountDetailsPanel;

        // Factory.addPanel(PanelNames.AccountDetailsPanel, null);
        this.addControl(this.myAccountDetailsPanel);
        if (!this.myAccountDetailsPanel)
            return;

        this.myAccountDetailsPanel.set({ visible: false });
        this.myAccountDetailsPanel.on('complete', function ()
        {
            const qt = this.getQuickTable();
            qt.onTableMouseUP.Subscribe(this$.onTableMouseUP, this$);
            qt.onTableMouseDown.Subscribe(this$.onTableMouseDown, this$);
            qt.onTableMouseMove.Subscribe(this$.onTableMouseMove, this$);
            this.observe("visible", function (val)
            {
                MainWindowManager.MainWindow.Controls.accountWidget.set("focusedAccWidget", val)
            })

            let items = []
            if (!Resources.isHidden('screen.export.visibility'))
                items.push(
                    {
                        text: Resources.getResource('screen.export.contextMenu'),
                        event: ExportScreen.show.bind(null, this)
                    }
                );
            qt.setTableContextMenuItems(items);

            Control.Ticker.Subscribe(this.TickAsync, this);

            this$.myAccountDetailsPanel.myAccLookup.observe('selectedItem', function (n, o)
            {
                if (o)
                {
                    o.OnUpdateAssetBalanceData.UnSubscribe(this$.AccountPanelReinit, this$);
                    o.OnDayTraderPatternChanged.UnSubscribe(this$.AccountPanelReinit, this$);
                }
                if (n)
                {
                    n.OnUpdateAssetBalanceData.Subscribe(this$.AccountPanelReinit, this$);
                    n.OnDayTraderPatternChanged.Subscribe(this$.AccountPanelReinit, this$);
                }

                if (this$.leftDataProvider &&
                    !this$.leftDataProvider.GetVerticalPanelValueHandler(this$.leftRowId, this$.leftDataProvider, this$.leftDataProvider.sett, this$.leftClicked))
                {   // при смене аккаунта значение в левом Info AccountWidget-а отсутствует (скрыто для выбранного ака) -> сменим на первую видимую строку с данными 
                    let itemId = this$.getFirstVisibleRowWithItem(),
                        dragedData = this$.getDragedRowId(itemId);
                    this$.leftRowId = dragedData.Id
                    this$.leftParams = dragedData.Parameters
                    this$.leftValueSkip = this$.leftParams.Hidden;
                    this$.leftClicked = itemId;
                    this$.set({ leftHeader: Resources.getResource(this$.leftParams.HeaderKey) });
                    this$.set({ lefttooltip: Resources.IsResourcePresent(this$.leftParams.TooltipKey) ? Resources.getResource(this$.leftParams.TooltipKey) : Resources.getResource(this$.leftParams.HeaderKey) });
                }

                if (this$.rightDataProvider &&
                    !this$.rightDataProvider.GetVerticalPanelValueHandler(this$.rightRowId, this$.rightDataProvider, this$.rightDataProvider.sett, this$.rightClicked))
                {   // при смене аккаунта значение в правом Info AccountWidget-а отсутствует (скрыто для выбранного ака) -> сменим на первую видимую строку с данными
                    let itemId = this$.getFirstVisibleRowWithItem(),
                        dragedData = this$.getDragedRowId(itemId);
                    this$.rightRowId = dragedData.Id
                    this$.rightParams = dragedData.Parameters
                    this$.rightValueSkip = this$.rightParams.Hidden;
                    this$.rightClicked = itemId;
                    this$.set({ rightHeader: Resources.getResource(this$.rightParams.HeaderKey) });
                    this$.set({ righttooltip: Resources.IsResourcePresent(this$.rightParams.TooltipKey) ? Resources.getResource(this$.rightParams.TooltipKey) : Resources.getResource(this$.rightParams.HeaderKey) });
                }

                if (Account.IsEqualAccount(n, o))
                    return
                SessionSettings.save()
            });
            this$.myAccountDetailsPanel.assetComboBox.observe('selectedItem', function (n, o)
            {
                if (Asset.IsEqualAsset(n, o))
                    return
                SessionSettings.save()
            });
            this$.myAccountDetailsPanel.assetComboBox.on('complete', function ()
            {
                if (this$.myAccountDetailsPanel)
                    if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_EXT_RISK) && this.get('items').length > 1)
                        if (this$.myAccountDetailsPanel.setAssetItems(this.get('items'), this$.myAccountDetailsPanel.myAccount, this$.assetComboBoxValue))
                        {
                            let item = this.get("selectedItem");
                            let asset = item.value.Name;

                            let dp = this$.myAccountDetailsPanel.VerticalPanelDataProvider;
                            let accItems = dp.Source;
                            let assetBalanceItem = accItems[0];

                            let keys = Object.keys(this$.myAccountDetailsPanel.myAccount.assetBalances[asset].AssetAdditionalInfo);
                            if (keys.length <= 0)
                                return

                            let leftkey = keys[0]
                            let rightkey = keys[1]

                            this$.leftRowId = leftkey
                            this$.set({ leftHeader: Resources.getResource(leftkey) });
                            this$.set({ lefttooltip: Resources.getResource(leftkey) });

                            this$.rightRowId = rightkey
                            this$.set({ rightHeader: Resources.getResource(rightkey) });
                            this$.set({ righttooltip: Resources.getResource(rightkey) });

                            SessionSettings.save();
                        }
                this$.callBack(this$.Properties())
            })
            // this$.callBack(this$.PrewProp)
            this$.UpdateDataRelation();
        })
    }
    else
    {
        this.myAccountDetailsPanel.repopulate();
        this.callBack(this.Properties())
    }
}

AccountWidget.prototype.resizeBtns = function ()
{
    if (!this.get("DragNDropInProcess"))
    {
        let myAll = document.getElementsByClassName("accountWidgetDivStyle")[0];
        let leftinfo = document.getElementsByClassName("js-accWidget-leftinfo")[0];
        let rightinfo = document.getElementsByClassName("js-accWidget-rightinfo")[0];
        let AccountWidgetBTN = document.getElementsByName("accountMenu")[0];
        let btnInfo = document.getElementsByClassName("js-button-info")[0];
        // if (myAll)
        //     myAll.style.width = leftinfo.offsetWidth + rightinfo.offsetWidth + AccountWidgetBTN.offsetWidth + btnInfo.offsetWidth + 3 + "px";
    }
    else
    {
        let myAll = document.getElementsByClassName("accountWidgetDivStyle")[0];
        let AddWidget = document.getElementsByClassName("js-accWidget-AddWidget")[0];
        let AccountWidgetBTN = document.getElementsByName("accountMenu")[0];
        let btnInfo = document.getElementsByClassName("js-button-info")[0];
        // if (myAll)
        //     myAll.style.width = AddWidget.offsetWidth * 2 + AccountWidgetBTN.offsetWidth + btnInfo.offsetWidth + 1 + "px";
    }
}

//TODO может херня
AccountWidget.prototype.onTableMouseUP = function (hittestInfo)
{
    this.clickedRowIndex = null;
    this.DragNDropInProcess = false;
    this.set({ DragNDropInProcess: false }).then(function ()
    {
        this.resizeBtns();
    }.bind(this));
}
AccountWidget.prototype.onTableMouseDown = function (hittestInfo)
{
    if (hittestInfo.rowIndex === -1)
        return;
    this.clickedRowIndex = hittestInfo.rowIndex;
}
AccountWidget.prototype.onTableMouseMove = function (hittestInfo)
{
    if (!this.clickedRowIndex)
        return;

    if (hittestInfo.rowIndex !== this.clickedRowIndex && !this.DragNDropInProcess)
    {
        this.DragNDropInProcess = true;
        this.set({ DragNDropInProcess: true }).then(function ()
        {
            this.resizeBtns();
        }.bind(this));;
    }
}

AccountWidget.prototype.ShowAccountDetailsPanel = function (coordinates)
{
    if (!this.myAccountDetailsPanel || this.myAccountDetailsPanel && this.myAccountDetailsPanel.torndown)
        this.AccountPanelReinit();

    if (coordinates)
        this.myAccountDetailsPanel.set({ left: coordinates.X, top: coordinates.Y });

    this.myAccountDetailsPanel.layoutTable();

    this.myAccountDetailsPanel.set({ visible: true });

    this.myAccountDetailsPanel.myAccLookup?.alignToEnd();

    this.set({ visibleInfoBtn: true })

    this.setFocus();
}

AccountWidget.prototype.getFirstVisibleRowWithItem = function ()
{
    if (!this.myAccountDetailsPanel)
        return

    let rowsArr = this.myAccountDetailsPanel.quickTableRactive.quickTable.rowsArray

    for (let i = 0; i < rowsArr.length; i++)
        if (rowsArr[i].visible && rowsArr[i].item)
            //fucking fix
            // coment below will explain all
            return i     // return i may fix problem with loading KYRREX #87035

    return null
}

AccountWidget.prototype.lostFocus = function ()
{
    if (this.myAccountDetailsPanel)
        this.myAccountDetailsPanel.hide();

    this.set({ visibleInfoBtn: false })
}

AccountWidget.prototype.dispose = function ()
{
    Control.Ticker.UnSubscribe(this.UpdateData, this);
    DataCache.OnReintialize.UnSubscribe(this.AccountPanelReinit, this);
    Resources.onLocaleChange.UnSubscribe(this.Localize, this);
};